import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Grid, Dropdown, Table, Button, Input, Loader, Container} from 'semantic-ui-react';
import {Actions} from '../../common/actions';
import {downloadFile} from '../../common/util/file';
import VehiclesTable from './vehiclesTable';
import VehiclesInfTable from './vehiclesInfTable';
import './audit.scss';

const typeSelec = [
  {'key': '2', 'value': 'CHASIS', 'text': 'CHASIS'},
  {'key': '3', 'value': 'PEDIDO', 'text': 'PEDIDO'},
];

class VehAudi extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'type': 'CHASIS',
      'dat': '',
      'line': '0',
      'filterOrderText': '',
      'activeTabIndex': '0',
    };
  }

  componentDidMount() {
    this.props.deleteVehAudiReport();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.urlFile !== this.props.urlFile && this.props.urlFile) {
      downloadFile(this.props.urlFile);
      this.props.deleteUrlVehAudi();
    }
  }

  changeTabIndex = (event, data) => {
    this.setState({'activeTabIndex': data.activeIndex});
  };

  search = () => {
    const {type, dat, line} = this.state;
    this.props.fetchVehAudiReport(type, dat, line);
    console.log('ok');
    this.props.fetchVehAudiInf(type, dat, line);
  };

  download = () => {
    this.renderPanesContentReportToexcel();
  };

  onOrderFilterChange = (event) => {
    this.setState({
      'dat': event.target.value.toUpperCase(),
    });
  }
  onLineFilterChange = (event) => {
    this.setState({
      'line': event.target.value.toUpperCase(),
    });
  }


  renderLine() {
    const {type, line} = this.state;
    if (type === 'PEDIDO') {
      return (
        <React.Fragment>
          <label><strong>  Línea</strong></label>
          <Input
            name='line'
            placeholder='Ingrese el número de línea'
            maxLength='4'
            error={!line}
            value={line}
            onChange={this.onLineFilterChange}
            required
          />
        </React.Fragment>
      );
    }
  }

            
  renderSearchButton() {
    const {loading} = this.props;
    return (
      <Button
        primary
        className='toyota-primary'
        disabled={loading}
        onClick={this.search}
      >
        Consultar
      </Button>
    );
  }

  renderPanesContentVehicle() {
    const {vehInf} = this.props;
    return <VehiclesInfTable setReportList={vehInf} />;
  }

  renderPanesContent() {
    const {setReportList} = this.props;
    return <VehiclesTable setReportList={setReportList} />;
  }

  renderPanesContentReportToexcel() {
    const {type, dat} = this.state;
    return this.props.downloadVehAudiReportFile(type, dat);
  }


  renderLoaderOrStock() {
    return (
      <Table striped className='toyota-grid'>
        <Table.Body>
          <Table.Row>
            <Table.Cell colSpan='100%'>
              <Loader active inline='centered' content='Ejecutando' />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }

  render() {
    const {type, dat} = this.state;
    const {loading, loadButton} = this.props;

    return (
      <div className='set-sales-list'>
        <Card raised fluid>
          <div className='title'></div>
          <div className='filters-section'>
            <Grid padded>
              <Grid.Row>
                <Grid.Column width={5} textAlign='left'>
                  <h2>Auditoría de Vehículos</h2>
                </Grid.Column>
                <Grid.Column width={6}>
                  <div className='title-bar-actions'>
                    <Dropdown
                      selection
                      search
                      value={type}
                      onChange={(e, {value}) =>
                        this.setState({'type': value})
                      }
                      name='list-invoices-container'
                      options={typeSelec}
                      placeholder='Seleccionar mes'
                    />
                    <Input
                      placeholder='# información'
                      value={dat}
                      onChange={this.onOrderFilterChange}
                      required
                    />
                    {this.renderLine()}
                  </div>
                </Grid.Column>
                <Grid.Column width={5} textAlign='right'>
                  <div className='title-bar-actions'>
                    {this.renderSearchButton()}
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>
        </Card>
        <Card fluid raised className='veh-audit-container'>
          {loadButton ? this.renderLoaderOrStock() : this.renderPanesContentVehicle()}
        </Card>
        <Card fluid raised className='veh-audit-container'>
          <Container style={{'width': '80%'}}>
            {loading ? this.renderLoaderOrStock() : this.renderPanesContent()}
          </Container>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
    'setReportList': state.vehAudi.list,
    'setReportListSet': state.vehAudi.listSet,
    'loading': state.vehAudi.loading,
    'loadButton': state.vehAudi.loadButton,
    'urlFile': state.vehAudi.urlFile,
    'vehInf': state.vehAudi.vehInf,
  };
};

const {
  fetchVehAudiReport,
  deleteVehAudiReport,
  fetchVehAudiSetReport,
  downloadVehAudiSetReportFile,
  deleteUrlVehAudi,
  downloadVehAudiReportFile,
  fetchVehAudiInf,
} = Actions;

export default connect(mapStateToProps,
  {
    fetchVehAudiReport,
    deleteVehAudiReport,
    fetchVehAudiSetReport,
    downloadVehAudiSetReportFile,
    deleteUrlVehAudi,
    downloadVehAudiReportFile,
    fetchVehAudiInf,
  })(VehAudi);
